module.exports = __webpack_public_path__ + "static/media/hot01.aa4b24fd.jpg";